import * as types from './mutation-types'

export default {
    [types.SET_TAB]: (state, tab) => {
        state.tab = tab
    },
    [types.SET_GENDER]: (state, gender) => {
        state.gender = gender
    },
    [types.SET_AGE]: (state, age) => {
        state.age = age
    },
    [types.SET_NOOF_PHOTOS]: (state, no) => {
        state.noofPhotos = no
    },
}